import { useTranslation } from 'react-i18next'
import { formatDateTime } from '../../modules/datetime/utils'
import { DATE_FORMAT_HUMAN } from '../../modules/datetime/constants'
import type { DailyGovernment } from './ResultHistory.types'

export interface FiveColumnResultCardsProps {
  rows: DailyGovernment[]
  t: (key: string) => string
}

export function FiveColumnResultCards({ rows, t }: FiveColumnResultCardsProps) {
  const { i18n } = useTranslation()

  return (
    <div className="space-y-3">
      {rows.map((row) => (
        <div
          key={row.date}
          className="overflow-hidden rounded-xl border border-[var(--card-divider)] bg-[var(--card-bg)] shadow-sm"
        >
          <div className="active-gradient px-4 py-3">
            <div className="text-lg font-semibold text-[var(--tab-text-active)]">
              {formatDateTime(DATE_FORMAT_HUMAN, row.date, i18n.language)}
            </div>
          </div>
          <div>
            <div className="grid grid-cols-5 border-t border-[var(--card-divider)] bg-[var(--bg-secondary)]">
              <div className="px-1 py-2 text-center text-[10px] sm:text-xs font-medium uppercase tracking-wide text-[var(--color-primary-400)]">
                {t('resultPage.columnThreeTop')}
              </div>
              <div className="px-1 py-2 text-center text-[10px] sm:text-xs font-medium uppercase tracking-wide text-[var(--color-primary-400)]">
                {t('resultPage.columnTwoUnder')}
              </div>
              <div className="px-1 py-2 text-center text-[10px] sm:text-xs font-medium uppercase tracking-wide text-[var(--color-primary-400)]">
                {t('resultPage.columnThreeFront')}
              </div>
              <div className="px-1 py-2 text-center text-[10px] sm:text-xs font-medium uppercase tracking-wide text-[var(--color-primary-400)]">
                {t('resultPage.columnThreeUnder')}
              </div>
              <div className="px-1 py-2 text-center text-[10px] sm:text-xs font-medium uppercase tracking-wide text-[var(--color-primary-400)]">
                {t('resultPage.columnTwoTop')}
              </div>
            </div>
            <div className="grid grid-cols-5 border-t border-[var(--card-divider)] bg-[var(--card-bg)]">
              <div className="px-1 py-3 text-center text-base sm:text-xl leading-tight font-semibold text-[var(--heading-text)]">
                {row.threeTop}
              </div>
              <div className="px-1 py-3 text-center text-base sm:text-xl leading-tight font-semibold text-[var(--heading-text)]">
                {row.twoUnder}
              </div>
              <div className="px-1 py-3 text-center text-base sm:text-xl leading-tight font-semibold text-[var(--heading-text)]">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-center sm:gap-2">
                  <span>{row.threeFront1}</span>
                  <span className="hidden sm:inline text-[var(--card-divider)]">
                    |
                  </span>
                  <span>{row.threeFront2}</span>
                </div>
              </div>
              <div className="px-1 py-3 text-center text-base sm:text-xl leading-tight font-semibold text-[var(--heading-text)]">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-center sm:gap-2">
                  <span>{row.threeUnder1}</span>
                  <span className="hidden sm:inline text-[var(--card-divider)]">
                    |
                  </span>
                  <span>{row.threeUnder2}</span>
                </div>
              </div>
              <div className="px-1 py-3 text-center text-base sm:text-xl leading-tight font-semibold text-[var(--heading-text)]">
                {row.twoTop}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
